import React, { Component, Fragment } from 'react'
import { FormattedMessage } from 'react-intl'

import { LayoutPlain, Header } from 'components/layout'
import { MaterialLoader } from 'components/loaders'
import { apiConfiguration, apiPayment } from 'helpers/decorators/api'
import PropTypes from 'prop-types'
import { Title } from 'components/misc'
import { PaymentGPForm } from 'components/forms'
import gpConfig from 'constants/misc/globalPayment'

import styles from './payment-gp-init.styl'
import { CONFIGURATION_KEYS } from '../../../constants/enums'
import { get } from 'lodash'
import { connect } from 'react-redux'

const STATUS = {
  START: 0, // API is contacted to init GP payment
  ERROR: -1, // something went wrong
  INITIALIZED: 1, // We've got request JSON from gateway and user is filling the data
  PROCESSING: 2 // after gateway callback we have response JSON and API is contacted to finish GP payment
}

@connect(({ api }) => ({
  configuration: api.configuration
}))
@apiPayment()
@apiConfiguration()
class PaymentGPInit extends Component {
  static propTypes = {
    initializeGp: PropTypes.func,
    processGpPayment: PropTypes.func,
    onGetConfigurationValue: PropTypes.func,
    configuration: PropTypes.object
  }

  state = {
    hppData: null,
    error: null,
    status: STATUS.START
  }

  async componentDidMount() {

    if (__SERVER__) {
      return
    }

    await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.gpServiceUrl.id, 1, true)

    try {
      window.addEventListener('message', this.receiveMessage, false)

      const hppData = await this.props.initializeGp()
      this.setState({ hppData, status: STATUS.INITIALIZED })
    } catch (error) {
      this.handleError(error)
    }
  }

  handleError = error => {
    console.error(error)
    this.setState({ error, status: STATUS.ERROR })
  }

  receiveMessage = async event => {
    try {
      const message = event.data.message

      if (message === 'gp-process-message') {
        this.setState({ status: STATUS.PROCESSING })
        const responseData = event.data.value

        await this.props.processGpPayment(responseData)
      }
    } catch (error) {
      this.handleError(error)
    }
  }

  render() {
    const { hppData, status } = this.state

    const { configuration } = this.props

    const gpServiceUrl = get(configuration, `values[${CONFIGURATION_KEYS.gpServiceUrl.id}].textValue`)

    const amount = get(hppData, 'AMOUNT')

    const currency = get(hppData, 'CURRENCY')

    const desc = get(hppData, 'COMMENT1')

    return (
      <LayoutPlain
        header={<Header isLocaleHidden />}
        body={[
          <Fragment>

            {status === STATUS.INITIALIZED && <div>
              <div className={styles.payment_overview}>
                <div className={styles.payment_overview_banner}>
                  <h1><span>Payment Overview</span></h1>
                </div>
                <div className={styles.payment_info}>
                  <p>{desc} Amount to pay: {amount} {currency}</p></div>
              </div>
              <iframe seamless name={gpConfig.IFRAME_ID} className={styles.iframe}></iframe>
            </div>
            }

            <div>
              {status === STATUS.ERROR &&
                <Fragment>
                  <Title h1 intlKey="moduleTitle.payment" className="base-margin--top">
                    Participant registration fees payment
                  </Title>
                  <Title h3 intlKey="label.problem_with_payment">
                  There was a problem processing your payment. Please contact your
                  National Award Operator (NAO).
                  </Title>
                </Fragment>
              }

              {status === STATUS.START &&
                <h1>
                  <MaterialLoader />{' '}
                  <span style={{ marginLeft: 10, position: 'relative', top: -7 }}>
                    <FormattedMessage
                      id="label.loading_gp_gateway"
                      defaultMessage="Loading Global Payments Gateway"
                    />
                  </span>
                </h1>
              }

              {status === STATUS.INITIALIZED &&

                <div>
                  <PaymentGPForm
                    hppData={hppData}
                    iframeId={gpConfig.IFRAME_ID}
                    buttonId={gpConfig.SUBMIT_BUTTON_ID}
                    gpServiceUrl={gpServiceUrl}
                  />
                </div>
              }

              {status === STATUS.PROCESSING &&
              <h1>
                <MaterialLoader />{' '}
                <span style={{ marginLeft: 10, position: 'relative', top: -7 }}>
                    <FormattedMessage
                      id="label.processing_gp_payment"
                      defaultMessage="Processing your payment"
                    />
                  </span>
              </h1>
              }
            </div>
          </Fragment>
        ]}
      />
    )
  }
}

export default PaymentGPInit
